import en from "./en.js"

export const DEFAULT_LOCALE = 'en';

export const LANGUAGES = [
    {
        label: "English",
        value: DEFAULT_LOCALE,
        image: "/images/en.png"
    },
]

export const LOCALES = LANGUAGES?.map(item => item.value)

export default function dictionary(key) {
    const obj = {
        en,
    }

    if (!LOCALES.includes(key)) {
        return obj[DEFAULT_LOCALE]
    }

    return obj[key]
}